import * as moment from 'moment';

import { IFilterItem, IFilterSection } from '@se-admin/falcon';

export { buildLabelsForTravelPeriodSection, toSelectedItems, TravelPeriodSectionTabs };

const toSelectedItems: (filterSection: IFilterSection) => IFilterItem[] = filterSection => {
  return filterSection.subSections.reduce((acc, subSection) => {
    return [...acc, ...subSection.items.filter(filterItem => filterItem.checked)];
  }, []);
};

const buildLabelsForTravelPeriodSection: (
  startDate: string,
  endDate: string,
  locale: string
) => string[] = (startDate, endDate, locale) => {
  return [
    `${moment(startDate)
      .locale(locale)
      .format('L')} - ${moment(endDate)
      .locale(locale)
      .format('L')}`,
  ];
};

enum TravelPeriodSectionTabs {
  Dates = 'dates',
  Months = 'months',
}
